export const toValidCurrency = (currency: string): string => {
  if (currency === 'USDC' || currency === 'USDT') {
    return 'USD';
  }

  return currency;
};
